// All portfolio content lives here so it can be edited or replaced easily.

export const PROFILE = {
  name: "Sahil Paruthi",
  title: "Senior Manager – Creative & Content Operations",
  tagline: "Creative Leadership | Content Operations | Brand Communication | Production & Design",
  coreMessage:
    "Turning business requirements into impactful creative communication through strong creative leadership, structured operations, and end-to-end execution.",
  email: "paruthisahil66@gmail.com",
  phone: "+91 7837142002",
  location: "Bengaluru, India",
  resumeUrl: "/Sahil-Paruthi-Resume.pdf",
  photo: "/sahil-paruthi.jpg",
  linkedin: "https://www.linkedin.com/in/sahilparuthi",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Experience", href: "#experience" },
  { label: "Capabilities", href: "#capabilities" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Tools", href: "#tools" },
  { label: "Contact", href: "#contact" },
];

export const FRAMEWORK = [
  {
    id: "creative",
    title: "Creative",
    text: "14+ years across creative design, brand communication and digital content — translating business requirements into impactful visual communication.",
  },
  {
    id: "operations",
    title: "Operations",
    text: "Structured creative and content operations: creative calendars, production schedules, asset repositories and workflow improvement.",
  },
  {
    id: "leadership",
    title: "Leadership",
    text: "Aligning people and creative resources around a shared system — directing designers, editors, videographers and vendors toward clear priorities and consistent quality.",
  },
  {
    id: "execution",
    title: "Execution",
    text: "End-to-end production management across digital, social, print, packaging, web and events — from brief to publishing-ready delivery.",
  },
];

export const TIMELINE = [
  {
    id: "sriveda-current",
    company: "Sriveda Sattva Pvt. Ltd.",
    division: "Sri Sri Tattva – FMCG",
    role: "Sr. Manager – Creative & Content Operations",
    period: "April 2026 – Present",
    location: "Bengaluru",
    current: true,
    points: [
      "Own end-to-end creative and content requirements across social, institutional and campaign communication",
      "Manage creative production workflows, internal creative resources and external vendors",
      "Coordinate designers, editors and videographers across video and content production",
      "Drive creative calendars, production schedules, asset repositories and quality assurance",
    ],
  },
  {
    id: "kimoha",
    company: "Kimoha Technologies Pvt. Ltd.",
    division: "",
    role: "Manager – Graphics Design",
    period: "June 2023 – April 2026",
    location: "Mohali",
    points: [
      "Managed graphics design requirements and creative delivery for the organisation",
      "Led design execution across digital and print communication",
      "Coordinated with stakeholders to translate requirements into production-ready creatives",
    ],
  },
  {
    id: "indrasur",
    company: "IndraSur Consulting Services Pvt. Ltd.",
    division: "",
    role: "Senior Graphics & Web Designer",
    period: "March 2020 – June 2023",
    location: "Mohali",
    points: [
      "Delivered graphics and web design across presentations, one-pagers, proposal covers, whitepapers, handbooks, newsletters and reports",
      "Handled digital creatives across social media and online campaigns",
      "Supported brand and marketing communication for consulting deliverables",
    ],
  },
  {
    id: "epilogue",
    company: "Epilogue",
    division: "Branding & Advertising Agency",
    role: "Senior Creative Designer",
    period: "October 2019 – February 2020",
    location: "Chandigarh",
    points: [
      "Created branding and advertising work across campaigns and print media",
      "Produced newspaper advertisements, hoardings, banners, brochures, pamphlets, posters, standees and merchandise",
    ],
  },
  {
    id: "sriveda-manager",
    company: "Sriveda Sattva Pvt. Ltd.",
    division: "Sri Sri Tattva – FMCG",
    role: "Manager – Creative Designs",
    period: "June 2015 – October 2019",
    location: "Bengaluru",
    points: [
      "Led the graphic design team with work allocation, creative direction and quality control",
      "Managed packaging materials, product communication and product labels",
      "Delivered brand, digital, social, e-commerce and institutional communication across functions",
    ],
  },
  {
    id: "ids",
    company: "IDS Infotech Pvt. Ltd.",
    division: "Book Publishing Company",
    role: "Graphic Designer",
    period: "August 2013 – May 2015",
    location: "Mohali",
    points: [
      "Produced scientific illustrations, maps, graphs, tables and charts for publishing",
      "Handled pre-press production for book publishing deliverables",
    ],
  },
  {
    id: "peep",
    company: "Peep India",
    division: "English Weekly Newspaper",
    role: "Graphic Designer",
    period: "May 2014 – April 2015",
    location: "Mohali",
    points: [
      "Designed layouts and creatives for a weekly English newspaper",
      "Produced newspaper advertisements and editorial design assets",
    ],
  },
  {
    id: "cweb",
    company: "CWeb Consultants",
    division: "Web & Mobile App Development",
    role: "Web Designer",
    period: "March 2013 – June 2013",
    location: "Chandigarh",
    points: [
      "Designed web interfaces for web and mobile app development projects",
    ],
  },
  {
    id: "webnnor",
    company: "Webnnor Infomatics Pvt. Ltd.",
    division: "",
    role: "Graphics & Web Designer",
    period: "October 2012 – December 2012",
    location: "Chandigarh",
    points: [
      "Delivered graphics and web design work for client projects",
    ],
  },
];

export const FEATURED_CAPABILITIES = [
  { title: "End-to-End Creative Requirements", text: "Owning complete creative and content requirements from brief to delivery." },
  { title: "Social & Digital Content", text: "Social media creatives, carousels, infographics and research-based visuals." },
  { title: "Product & Ingredient Explainers", text: "Clear, credible product and ingredient communication for FMCG audiences." },
  { title: "Institutional & Campaign Communication", text: "Institutional communication, campaign creatives, events and expert sessions." },
  { title: "Production Workflows", text: "Creative production workflows, calendars, schedules and publishing readiness." },
  { title: "Team & Vendor Coordination", text: "Internal creative resources, external vendors, designers, editors and videographers." },
  { title: "Video & Content Production", text: "Coordinating video and content production across contributors and channels." },
  { title: "Stakeholder Management", text: "Cross-functional stakeholder coordination across marketing, product and more." },
  { title: "Asset Repositories & QA", text: "Organised asset repositories, quality assurance and creative workflow improvement." },
];

export const CAPABILITIES = [
  { icon: "workflow", title: "Creative & Content Operations", text: "Structured workflows, creative calendars and production schedules that keep content moving." },
  { icon: "users", title: "Creative Team Leadership", text: "Leading and coordinating designers, editors and videographers across projects and channels." },
  { icon: "rocket", title: "End-to-End Creative Execution", text: "From brief to publishing-ready delivery across channels and formats." },
  { icon: "badge", title: "Brand Identity & Visual Consistency", text: "Logos, corporate branding and brand guidelines applied with discipline." },
  { icon: "calendar", title: "Production Planning & Delivery", text: "Production planning, coordination and quality-focused delivery." },
  { icon: "network", title: "Cross-Functional Stakeholder Coordination", text: "Working across marketing, product, e-commerce, customer service, purchasing and institutional teams." },
  { icon: "handshake", title: "Vendor & External Partner Management", text: "Coordinating external vendors and creative partners for reliable output." },
  { icon: "megaphone", title: "Digital, Social & Campaign Creative", text: "Social creatives, carousels, infographics and digital campaigns." },
];

export const ECOSYSTEM = [
  { title: "Brand & Identity", items: ["Logos", "Corporate branding", "Brand guidelines"] },
  { title: "Digital & Social", items: ["Social media creatives", "Carousels", "Digital campaigns"] },
  { title: "Marketing & Communication", items: ["Presentations", "One-pagers", "Proposal covers", "Whitepapers", "Handbooks", "Newsletters", "Reports"] },
  { title: "Product & Packaging", items: ["Packaging materials", "Product communication", "Product labels"] },
  { title: "Institutional & Events", items: ["Institutional communication", "Seminars", "Expert sessions", "Highlight reels", "Promotional materials"] },
  { title: "Advertising & Print", items: ["Newspaper advertisements", "Hoardings", "Banners", "Brochures", "Pamphlets", "Posters", "Standees", "Merchandise"] },
  { title: "Publishing", items: ["Scientific illustrations", "Maps", "Graphs", "Tables", "Charts", "Pre-press production"] },
];

export const LEADERSHIP_THEMES = [
  "Team Leadership",
  "Creative Direction",
  "Work Allocation",
  "Stakeholder Coordination",
  "Vendor Coordination",
  "Quality Control",
  "Conflict Resolution",
  "Decision Making",
  "Timeline Management",
  "Multitasking",
];

export const PROCESS_STEPS = [
  { id: "brief", label: "Brief", text: "Understanding business requirements and briefing the creative team with clarity." },
  { id: "plan", label: "Plan", text: "Creative calendars, production schedules and resource planning." },
  { id: "create", label: "Create", text: "Creative development across design, content and video production." },
  { id: "review", label: "Review", text: "Structured reviews and stakeholder feedback loops." },
  { id: "refine", label: "Refine", text: "Revisions and refinement with quality-focused iteration." },
  { id: "approve", label: "Approve", text: "Stakeholder approvals with brand and quality governance." },
  { id: "deliver", label: "Deliver", text: "Production execution and publishing-ready delivery." },
  { id: "publish", label: "Publish", text: "Publishing readiness and organised asset repositories." },
];

export const PROCESS_TRAITS = [
  "Briefing", "Planning", "Creative development", "Reviews", "Stakeholder feedback",
  "Revisions", "Approvals", "Production", "Publishing readiness", "Asset organization",
];

export const TOOL_GROUPS = [
  { title: "Creative", tools: ["Adobe Photoshop", "Adobe Illustrator", "CorelDRAW", "Figma"] },
  { title: "Productivity & Collaboration", tools: ["Microsoft 365", "Jira", "Confluence"] },
  { title: "Digital", tools: ["WordPress"] },
  { title: "AI", tools: ["ChatGPT", "Claude", "Emergent", "AI Design Tools"] },
  { title: "Documents", tools: ["Adobe Acrobat DC"] },
];

export const EDUCATION = {
  degree: "B.Sc. in Animation & Multimedia",
  institution: "Arena Animation | Manonmaniam Sundarnar University",
  year: "2013",
};

export const IMPACT = [
  {
    stat: "14+ Years",
    title: "Creative & design experience",
    text: "Across creative design, content operations, brand communication and production.",
  },
  {
    stat: "Multiple Functions",
    title: "Cross-functional reach",
    text: "Marketing • Product • E-commerce • Customer Service • Purchasing • Institutional Communication",
  },
  {
    stat: "End-to-End",
    title: "Complete ownership",
    text: "Brief → Creative → Review → Approval → Delivery",
  },
  {
    stat: "Multi-Channel",
    title: "Breadth of delivery",
    text: "Digital • Social • Print • Packaging • Web • Events",
  },
];

// Editable placeholders — replace title, description and image with real projects later.
export const PORTFOLIO_PROJECTS = [
  { id: "brand-identity", title: "Brand Identity Project", category: "Brand Identity", description: "Logo, corporate branding and brand guidelines work. Replace with a real project.", image: "" },
  { id: "social-media", title: "Social Media Creative", category: "Social Media", description: "Social media creatives, carousels and infographics. Replace with a real project.", image: "" },
  { id: "campaign", title: "Campaign Creative", category: "Campaign Creative", description: "End-to-end campaign creative across channels. Replace with a real project.", image: "" },
  { id: "packaging", title: "Packaging & Labels", category: "Packaging", description: "Packaging materials, product communication and product labels. Replace with a real project.", image: "" },
  { id: "presentations", title: "Presentations & Reports", category: "Presentations", description: "Presentations, one-pagers, whitepapers, handbooks and reports. Replace with a real project.", image: "" },
  { id: "digital-content", title: "Digital Content", category: "Digital Content", description: "Digital content and product/ingredient explainers. Replace with a real project.", image: "" },
  { id: "advertising", title: "Advertising & Print", category: "Advertising", description: "Newspaper ads, hoardings, banners, brochures and posters. Replace with a real project.", image: "" },
  { id: "institutional", title: "Institutional Communication", category: "Institutional Communication", description: "Institutional communication, seminars, expert sessions and highlight reels. Replace with a real project.", image: "" },
  { id: "publishing", title: "Publishing & Pre-press", category: "Publishing", description: "Scientific illustrations, maps, graphs, charts and pre-press production. Replace with a real project.", image: "" },
  { id: "web-design", title: "Web Design", category: "Web Design", description: "Web and interface design work. Replace with a real project.", image: "" },
];

export const PORTFOLIO_DISCLAIMER =
  "All creative work showcased in this portfolio was designed and created by me during my employment with the respective companies and for their clients. These works are presented solely for portfolio and evaluation purposes. All rights and ownership remain with the respective organizations.";

export const MARQUEE_ITEMS = [
  "Creative Leadership",
  "Content Operations",
  "Brand Communication",
  "Production & Design",
  "Stakeholder Management",
  "Team Leadership",
  "Multi-Channel Delivery",
];
